import { AvailableModules } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

type Props = {
  onClose: () => void
  isOpen?: boolean
}

const UpsellPromoModal = ({ onClose, isOpen = true }: Props) => {
  const benefits = [
    i18n.t('payroll_bundle.upsell.product_services_promo.modal.first_item.title'),
    i18n.t('payroll_bundle.upsell.product_services_promo.modal.second_item.title'),
    i18n.t('payroll_bundle.upsell.product_services_promo.modal.third_item.title'),
    i18n.t('payroll_bundle.upsell.product_services_promo.modal.fourth_item.title'),
  ]

  return (
    <UpsellingKit.ProductModal
      moduleRequested={AvailableModules.expenses}
      requestSource="Payroll policy page"
      requestReason={ValidReasons.Activation}
      pageSource="Payroll policy page"
      isOpen={isOpen}
      onClose={onClose}
      title={i18n.t('payroll_bundle.upsell.product_services_promo.modal.description')}
      benefits={benefits}
      openFromUpsellButton={false}
    />
  )
}

export default UpsellPromoModal
